app.service('orderConfig', function (pageConfig) {
	function getData() {
		return pageConfig.getData('order');
	}

	return {
		getData
	};
});
